import { createAction } from 'redux-starter-kit';

export const SET_QUESTIONS = 'questions/SET';
export const SET_RESPONSES = 'responses/SET';

export const setQuestions = createAction(SET_QUESTIONS);
export const setResponses = createAction(SET_RESPONSES);

export const experienceActions = {
  setQuestions,
  setResponses
};
